import classNames from 'clsx';
import React, { FC, memo } from 'react';
import type { ItemNameProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from '../DataListItemRow.css';

export const ItemName: FC<ItemNameProps> = memo(function ItemName({ name, ext, loading }) {
    return (
        <div className={classNames({ [styles.name]: true, [styles.loading]: loading })}>
            <NameComponent name={name} extension={ext} truncate showTooltip />
        </div>
    );
});
